<template>
  <el-dialog :title="title" :visible.sync="visible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" :show-message="showMessage" label-width="100px">
      <el-form-item label="反馈类型：">
        {{item.typeName}}
      </el-form-item>
      <el-form-item label="反馈内容：">
        {{item.content}}
      </el-form-item>
      <el-form-item label="反馈时间：">
        {{$date.format('yyyy-MM-dd hh:mm:ss', item.createdDate)}}
      </el-form-item>
      <el-form-item label="反馈用户：">
        {{item.username}}
      </el-form-item>
      <el-form-item label="联系方式：">
        {{item.contact}}
      </el-form-item>
      <el-form-item label="状态：">
        {{FEEDBACK_STATUS.get(item.status)}}
      </el-form-item>
      <el-form-item v-if="item.response" label="回复内容：">
        {{item.response}}
      </el-form-item>
      <el-form-item v-else label="回复内容：" prop="input">
        <el-input v-model="form.input" type="textarea" :rows="5" @focus="inputFocus"></el-input>
      </el-form-item>
      <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
        <el-form-item v-show="!showMessage && errTips !== ''" class="err-tips">
          <span><i class="el-icon el-icon-remove"></i>{{errTips}}</span>
        </el-form-item>
      </transition>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="!canSubmit" type="primary" style="width: 120px;" @click="handleUpdate">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { PUT_FEEDBACK } from '@/utils/api'
import { FEEDBACK_STATUS } from '@/utils/global-constant'

export default {
  name: 'EditDialog',

  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },

    item: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },

  data () {
    this.checkReason = (rule, value, callback) => {
      let errTips = ''
      if (value === '') {
        errTips = '请输入回复内容'
      }

      if (errTips) {
        !this.errTips && (this.errTips = errTips)
        callback(new Error(errTips))
      } else {
        callback()
      }
    }
    return {
      title: '',
      uploading: false,
      form: {
        input: '',
      },
      showMessage: true,
      rules: {
        input: [
          {required: true, validator: this.checkReason, trigger: 'blur'}
        ]
      },
      errTips: '',
      FEEDBACK_STATUS
    }
  },

  computed: {
    canSubmit () {
      return this.form.input !== ''
    }
  },

  watch: {
    visible (val) {
      if (this.item.hasOwnProperty('id')) {
        this.title = '回复反馈'
        this.form = Object.assign({
        }, this.item)
      } else {
        this.title= ''
        this.form = {
          input: ''
        }
      }
      setTimeout(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      }, val ? 0 : 300)
    },

    showMessage (val) {
      !val && (this.errTips = '')
    }
  },

  methods: {
    // 关闭前
    handleClose () {
      this.$emit('close')
    },

    // 数据更新前
    handleUpdate () {
      if (this.item.response) {
        return this.handleClose()
      }
      this.showMessage = false
      setTimeout(() => {
        this.submit()
      }, 10)
    },

    // 提交数据
    submit () {
      this.$refs.form &&
      this.$refs.form.validate(async validateResult => {
        if (validateResult) {
          try {
            const data = Object.assign({}, this.form)
            await PUT_FEEDBACK(this.item.id, data)
            this.$message.success('已回复')
            this.$emit('update')
          } catch (e) {
            this.$message.error('操作失败')
          }
        }
      })
    },

    // 输入框聚焦
    inputFocus () {
      !this.showMessage && this.$refs.form && this.$refs.form.clearValidate()
      this.showMessage = true
    },

    handleExceed (file, fileList) {
      this.$message.error('超出限制数量')
      return false
    },

    async handleChange (file, fileList) {
      // 新增或替换
      if ( !this.fileList.length ) {
        // 类型校验失败
        if (!this.beforeUpload(file, fileList)) { return this.$refs.upload.clearFiles() }
        try {
          this.uploading = true
          const { key } = await PUT_IMAGE_UPLOAD(file)
          this.form.fileKey = key
          this.fileList = [file]
        } catch (e) {
          this.fileList = []
        } finally {
          this.uploading = false
        }
      }
    },

    beforeUpload (file, fileList) {
      const type = file.name.split('.')
      if (type.length === 1 && !this.acceptType.includes(type[type.length - 1])) {
        this.$message.error('文件类型错误')
        return false
      } else {
        return true
      }
    },

    handleUploadSuccess ({data, code, msg}, file, fileList) {
      if (code !== 200) {
        this.$message.error('上传失败')
      } else {
        file.name = data.url.split('/').pop()
        this.form.latestDownloadUrl = data.url
        this.inputFocus()
      }
    },

    handleRemoveFile (file, fileList) {
      fileList.length === 0 && (this.form.latestDownloadUrl = '')
    }
  }
}
</script>

<style lang="scss" scoped>
.err-tips {
  color: #F26552;

  /deep/ .el-form-item__content {
    text-align: center;
    font-size: 16px;
    background: rgba(255,242,244,1);
    border: 1px solid rgba(242,161,150,1);
  }

  .el-icon {
    margin-right: .8rem;
  }
}

.el-dialog__wrapper {
  /deep/ .el-dialog__footer {
    text-align: center;
  }
}
</style>
